import React, { useState } from "react";

import { Card, Typography, Pagination, Table, Popconfirm, message } from "antd";
import CommonTopDetails from "../../../../components/AdminComponents/CommonTopDetails";
import { useParams } from "react-router-dom";
import useCommonListing from "../../../../components/AdminComponents/customHooks/useCommonListing";
import { GetFormattedDateTime } from "../../../../components/utils/DateTimeUtils";
import { DeleteTwoTone } from "@ant-design/icons";
import { useSelector } from "react-redux";
import BulkBundleAdd from "../../../../components/AdminComponents/Modals/BulkBundleAdd";
import axiosInstance from "../../../../api/Axios";

const { Title } = Typography;
const Bundles = (props) => {
  const userInfo = useSelector((state) => state.user);
  const { id } = useParams();
  const [loadAgain, setLoadAgain] = useState(false);
  const LoadAPI = () => {
    setLoadAgain((prev) => !prev);
  };

  const {
    data,
    itemsLength,
    loading,
    filterData,
    onShowSizeChange,
    onPageChange,
    handleSearchChange,
    // setFilterData,
    // handleSwitchChange,
    // handleClearAll,
    // setFilterUrl,
  } = useCommonListing({
    passSize: 10,
    passPage: 1,
    passURL: `/learn/coursebundlelist/?course_id=${id}&organization=${userInfo?.data?.organization?.id}`,
    loadAgain: loadAgain,
  });
  console.log(data);
  // eslint-disable-next-line no-unused-vars
  const { pageSize, currentPage, active, filter_url } = filterData;
  const [messageApi, contextHolder] = message.useMessage();
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");

  const DeleteSuccessfull = () => {
    messageApi.open({
      type: "success",
      content: "Course has been Removed.",
      duration: 5,
    });

    setLoadAgain(true);
    props.LoadUser();
  };
  const DeleteFalied = () => {
    messageApi.open({
      type: "error",
      content: "Course Remove Failed",
      duration: 5,
    });
  };
  const [isBulkModalOpen, setIsBulkModalOpen] = useState(false);
  const handleDelete = async (record) => {
    try {
      await axiosInstance.delete(
        `/learn/bundlecoursedelete/${record?.bundle_course_id}/${record?.child_course_id}/`,
        {
          headers: {
            "X-CSRFToken": csrfToken,
          },
        }
      );
      DeleteSuccessfull();
    } catch (err) {
      DeleteFalied();
    }
  };

  const columns = [
    {
      title: "Bundle ID",
      dataIndex: "bundle_id",
      key: "bundle_id",
      width: 140,
    },
    {
      title: "Bundle Name",
      dataIndex: "name",
      key: "name",
      width: 250,
    },

    {
      title: "Due Date",
      dataIndex: "due_date",
      key: "due_date",
      width: 150,
      render: GetFormattedDateTime,
    },

    ...(props?.ImpersonateAccess
      ? [
          {
            title: "Actions",
            dataIndex: "id",
            key: "id",
            align: "center",
            width: 150,
            render: (text, record) => (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Popconfirm
                  title={"Remove Bundle from this course?"}
                  description=" "
                  onConfirm={() => handleDelete(record)}
                  // onCancel={cancel}
                  okText="Yes"
                  cancelText="No"
                  placement="leftTop"
                >
                  <DeleteTwoTone
                    key="delete"
                    style={{
                      cursor: "pointer",
                      fontSize: "1.6rem",
                      marginLeft: "0.9rem",
                    }}
                    title="delete"
                    twoToneColor="#eb2f96"
                  />
                </Popconfirm>
              </div>
            ),
          },
        ]
      : []),
  ];
  return (
    <Card style={{ width: "100%", marginBottom: "10px" }} hoverable>
      {contextHolder}
      <Title level={5} style={{ marginInline: "10px" }}>
        Associated Bundles Summary
      </Title>
      <CommonTopDetails
        title={`Course Bundles`}
        titleSuffix={`${itemsLength || 0} bundle(s)`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        showAddButton={props?.ImpersonateAccess}
        filterAction={false}
        marginPass="15px"
        paddingInlinepass="10px"
        topSizeAdd="5px"
        addButtonProps={{
          modalType: "PopUP",
          modalProps: () => setIsBulkModalOpen((prev) => !prev),
        }}
      />
      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        size="small"
        loading={loading}
        className="table-container"
        style={{ margin: "1rem" }}
        pagination={false}
        scroll={{
          x: 500,
        }}
        bordered
      />

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "1rem",
        }}
      >
        <Pagination
          size="small"
          showSizeChanger
          onShowSizeChange={onShowSizeChange}
          onChange={onPageChange}
          pageSizeOptions={["5", "10", "15", "20", "50"]}
          //   showQuickJumper
          current={currentPage}
          defaultPageSize={pageSize}
          total={itemsLength}
        />
      </div>
      <BulkBundleAdd
        open={isBulkModalOpen}
        onClose={() => setIsBulkModalOpen(false)}
        userInfo={userInfo}
        course_id={id}
        LoadAPI={LoadAPI}
        callMain={props.LoadUser}
      />
    </Card>
  );
};

export default Bundles;
